import React from "react";
import FieldRouter from "./editor/FieldRouter";
import ObjectSection from "./editor/ObjectSection";

const ContentEditor = ({ value, onChange, path = "root", compact = false }) => {
  if (compact) return <ObjectSection compact value={value} onChange={onChange} path={path} />;

  return (
    <div className="space-y-5" data-testid="content-editor">
      {Object.entries(value || {}).map(([k, v]) => (
        <FieldRouter
          key={k}
          keyName={k}
          value={v}
          onChange={(nv) => onChange({ ...value, [k]: nv })}
          path={`${path}.${k}`}
        />
      ))}
    </div>
  );
};

export default ContentEditor;
